import { createTheme } from '@mui/material';
import { colors } from '../constants';

export const theme = createTheme({
    components: {
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                fullWidth: true,
            },
            styleOverrides: {
                root: {
                    marginBottom: '15px',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontFamily: 'Orgon',
                    color: colors.black,
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: colors.greyMedium,
                    '&&.Mui-focused': {
                        color: colors.black,
                    },
                    fontFamily: 'Orgon',
                    lineHeight: '1.7',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '.MuiOutlinedInput-notchedOutline': {
                        transition: 'border-color 0.25s linear',
                    },
                    '&&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.greyDark,
                    },
                    '&&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.black,
                        borderWidth: '1.5px',
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    marginBottom: '15px',
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: { marginLeft: '10px' },
                root: {
                    alignItems: 'flex-start',
                    padding: '0 10px 0',
                    marginBottom: '10px',
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    padding: '0px',
                    color: colors.black,
                    '&&.Mui-checked': {
                        color: colors.primary,
                    },
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                listbox: {
                    maxHeight: '250px',
                },
            },
        },
    },
});
